import { Checkbox, Upload } from 'antd';
import React from 'react';
import ImageUpload from './ImageUpload';
import { useGlobalState } from './GlobalState';

function Step3({ form }) {
  const [termsApproval, setTermsApproval] = useGlobalState('termsApproval1');
  const [termsApproval2, setTermsApproval2] = useGlobalState('termsApproval2');
  const [userImage, setUserImage] = useGlobalState('userImage');
  const [IDImage, setIDImage] = useGlobalState('IDImage');
  const [userFilePreviews, setUserFilePreviews] =
    useGlobalState('userFilePreview');
  const [IdFilePreviews, setIdFilePreviews] = useGlobalState('IdFilePreview');

  return (
    <div style={{ color: '#606060' }}>
      {form?.form_element.photo_upload && (
        <>
          <div className='fs-24 gSemiBold'>Image Upload:</div>
          <div className='membership-image-display'>
            <ImageUpload
              key={'user'}
              fileList={userImage}
              filePreviews={userFilePreviews}
              setFilePreviews={setUserFilePreviews}
              setFileList={setUserImage}
            />
          </div>
          <div className='gSemiBold txt-center mg-bottom-20'>
            Please upload an image of yourself. This image may be used by
            fishery / angling club professionals to identify you.
          </div>
        </>
      )}
      {form?.form_element.id_upload && (
        <>
          <div className='fs-24 gSemiBold'>
            ID Upload (e.g Passport or License):
          </div>
          <div className='membership-image-display'>
            <ImageUpload
              key={'ID'}
              boxText='Upload ID'
              fileList={IDImage}
              setFileList={setIDImage}
              filePreviews={IdFilePreviews}
              setFilePreviews={setIdFilePreviews}
            />
          </div>
          <div className='gSemiBold txt-center mg-bottom-20'>
            Please upload an image of your ID (e.g Passport or Driver’s
            License). This may be used by the fishery / angling club
            professionals to identify you.
          </div>
        </>
      )}
      <div className='fs-24 gSemiBold'>Declaration:</div>
      <div className='row-center mg-bottom-20'>
        <Checkbox
          checked={termsApproval}
          onChange={(e) => setTermsApproval(e.target.checked)}
          className='mg-right-15'
        />
        <div
          className='gSemiBold cp'
          onClick={() => {
            setTermsApproval((prev) => !prev);
          }}
        >
          {form.terms}
        </div>
      </div>
      {form?.terms2 && (
        <div className='row-center mg-bottom-20'>
          <Checkbox
            checked={termsApproval2}
            onChange={(e) => setTermsApproval2(e.target.checked)}
            className='mg-right-15'
          />
          <div
            className='gSemiBold cp'
            onClick={() => {
              setTermsApproval2((prev) => !prev);
            }}
          >
            {form.terms2}
          </div>
        </div>
      )}
    </div>
  );
}

export default Step3;
